// Il minimo dei contratti per reset e primo accesso.
const NEW_PASSWORD_MIN_LENGTH = 8;

const RULES = [
  {
    key: 'length',
    label: `Almeno ${NEW_PASSWORD_MIN_LENGTH} caratteri`,
    test: (password: string) => password.length >= NEW_PASSWORD_MIN_LENGTH,
  },
  {
    key: 'uppercase',
    label: 'Una lettera maiuscola',
    test: (password: string) => /[A-Z]/.test(password),
  },
  {
    key: 'lowercase',
    label: 'Una lettera minuscola',
    test: (password: string) => /[a-z]/.test(password),
  },
  { key: 'number', label: 'Un numero', test: (password: string) => /\d/.test(password) },
];

/** I requisiti della nuova password al primo accesso, ognuno con `met`, e se li rispetta tutti. */
export function checkFirstLoginPassword(password: string) {
  const rules = RULES.map(({ key, label, test }) => ({ key, label, met: test(password) }));
  return { rules, valid: rules.every((rule) => rule.met) };
}

export type ResetPasswordErrors = { password?: string; confirmation?: string };

/** Gli errori per campo della password scelta dal link di reset; vuoto se va bene. */
export function resetPasswordErrors(password: string, confirmation: string): ResetPasswordErrors {
  if (password.length < NEW_PASSWORD_MIN_LENGTH) {
    return { password: `La password deve avere almeno ${NEW_PASSWORD_MIN_LENGTH} caratteri` };
  }
  if (password !== confirmation) return { confirmation: 'Le password non coincidono' };
  return {};
}
